/**
 * 用户接口
 * 用户接口API
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The AccountVo model module.
   * @module account/model/AccountVo
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>AccountVo</code>.
   * @alias module:account/model/AccountVo
   * @class
   */
  var exports = function() {
    var _this = this;





  };

  /**
   * Constructs a <code>AccountVo</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:account/model/AccountVo} obj Optional instance to populate.
   * @return {module:account/model/AccountVo} The populated <code>AccountVo</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'id')) {
        obj['id'] = ApiClient.convertToType(data['id'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'phoneNum')) {
        obj['phoneNum'] = ApiClient.convertToType(data['phoneNum'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'code')) {
        obj['code'] = ApiClient.convertToType(data['code'], 'String');
      }
    }
    return obj;
  }

  /**
   * 账号ID
   * @member {Integer} id
   */
  exports.prototype['id'] = undefined;
  /**
   * 姓名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 手机号
   * @member {String} phoneNum
   */
  exports.prototype['phoneNum'] = undefined;
  /**
   * 工号
   * @member {String} code
   */
  exports.prototype['code'] = undefined;



  export default exports;
;


